import * as React from "react"
import styled, { PolymorphicComponentProps } from "styled-components"
import { ChevronDownIcon } from "../../icons/ChevronDown"
import { ChevronUpIcon } from "../../icons/ChevronUp"
import { DeprecatedMenuListButton } from "./menuListButton"

const MenuProfileButtonCmp = styled(DeprecatedMenuListButton)`
  height: 3rem;
  margin-bottom: 0.5rem;
`

const StyledChevronUpIcon = styled(ChevronUpIcon)`
  width: 1rem;
  height: 1rem;
`

const StyledChevronDownIcon = styled(ChevronDownIcon)`
  width: 1rem;
  height: 1rem;
`

const ChildrenWrapper = styled.span`
  margin-left: 1.5rem;
`

export type DeprecatedMenuProfileProps<C extends React.ElementType> = PolymorphicComponentProps<
  "web",
  {
    isOpen: boolean
    mode: "light" | "dark"
  },
  C,
  C
>

export const DeprecatedMenuProfileButton = <C extends React.ElementType = "button">({
  children,
  isOpen,
  mode,
  ...props
}: DeprecatedMenuProfileProps<C>) => (
  <MenuProfileButtonCmp mode={mode} {...props}>
    <ChildrenWrapper>{children}</ChildrenWrapper>
    {isOpen ? <StyledChevronUpIcon /> : <StyledChevronDownIcon />}
  </MenuProfileButtonCmp>
)
